import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Autocomplete from '../autocomplete';
import strings from '../../locales/';

class EntityInput extends Component {
  constructor(props, context) {
    super(props, context);
    var value = props.value;
    if(value==null || value=="null") {
      value="";
    }
    this.state = { 
      value: value, 
      alias: this.getAlias(value)
    };
  }

  onChange = (e) => {
    if(this.props.onClickHandler) {
      this.props.onClickHandler({target: {
        value:e.value,
        dataset: {update: this.props.dataUpdate},
        aliasValue: {
          value: this.getAlias(e.value),
          dataset: {update: this.props.entityType + "Alias"}
        }
      }});
    }
    this.setState({
      value: e.value,
      alias: this.getAlias(e.value)
    });
  };

  getAlias = (id) => {
    var alias = "";
    if(id==null || id=="null") {
      return alias;
    }
    var obj = this.props.entities.find(o => o.id == id);
    if(obj) {
      alias = obj.alias;
    }
    return alias;
  };

  filterEntities() {
    if(this.props.filterTag && this.props.filterTag.category
      && this.props.filterTag.tag && this.props.filterTag.tag!=""
      && this.props.filterTag.tag!="*") {
      return this.props.entities.filter(ent => {
        for(var i=0;i<ent.tags.length;i++) {
          var tagObj = ent.tags[i];

          if(tagObj.tag == this.props.filterTag.tag
            && tagObj.tagCategory == this.props.filterTag.category)
          {
            return true;
          }
        }
        return false;
      });
    }
    else {
      return this.props.entities;
    }
  }

  render() {
    return (
      <div className="entity-input modal-input">
        <Autocomplete 
          value={this.state.alias}
          save={""}
          required={true}
          id={this.props.entityType + "Alias"}
          alias="alias"
          select="id"
          idItem="id"
          filter={this.filterEntities()}
          handleSubmit={this.onChange}
          placeholder={this.props.placeholder}
        />
        <input
          autoComplete="off"
          value={this.state.value}
          type="hidden"
          id={this.props.id}
          className={this.props.className}
        />
      </div>
    );
  }
}

EntityInput.propTypes = {};

export default EntityInput;



// WEBPACK FOOTER //
// ./source/client/components/common/forms/entityInput.jsx